import React, { useEffect, useState } from "react";


import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Form, Input, message, Modal, Select } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { Dropdown, Menu, Button } from "antd";
import { MoreOutlined } from '@ant-design/icons';


import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { VEH_IMAGE_URL } from "../../Api/constants";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
} from '@mui/material';
import DataTable from "../../Components/DataTable";
import { capitalizeFirstLetter } from "../../config/functions";


const { Option } = Select;




const BookingRequests = () => {


    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);

    const [vehicle, setVehicle] = useState([]);
    const [requests, setRequests] = useState([]);

    const [activeTab, setActiveTab] = React.useState('allBookings');
    const [pending, setPending] = useState([]);
    const [approved, setApproved] = useState([]);
    const [rejected, setRejected] = useState([]);
    const [returned, setReturned] = useState([]);
    const [data, setData] = useState([]);
    const [deletedId, setDeletedId] = useState('');
    const [deletedModal, setDeletedModal] = useState(false);



    const history = useNavigate();


    const getBookingRequests = async () => {

        const onSuccess = (res) => {
            setRequests(res.data);
            setData(res.data);
            console.log('approved_booking_requests', res.approved_booking_requests)
            setPending(res.pending_booking_requests);
            setApproved(res.approved_booking_requests);
            setRejected(res.rejected_booking_requests);
            setReturned(res.returned_booking_requests);
            console.log('res.data', res.data);
        }

        const onError = (err) => {
            console.log('err', err);
            // alert(err)
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token
            // user?.token
        }

        await postRequest(body, apiRoutes.getBookingRequests, onSuccess, onError)

    }

    const checkBookingStatusForApprove = async (id, cb = () => { }) => {

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            booking_id: id
        }
        console.log('body___', body);

        const res = await postRequest(body, apiRoutes.checkBookingStatusForApprove);
        if (res.status == '1') return true;
        else return {
            status: false,
            message: res.error
        }
    }

    const deleteBookingRequest = async () => {
        const onSuccess = (res) => {
            message.success('Deleted!');
            setDeletedId('')
            getBookingRequests();
        }

        const onError = (err) => {
            console.log('err', err);
            setDeletedId('')
            // alert(err)
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            booking_id: deletedId
        };

        await postRequest(body, apiRoutes.deleteBookingRequest, onSuccess, onError);

    }

    const handleActionClick = async (key, record) => {
        let status = key == 'approve' ? "approved" : "rejected";
        if (key == 'delete') status = "delete";
        if (key == 'delete') {
            setDeletedId(record._id);
            setDeletedModal(true);
            // deleteBookingRequest(record._id);
            return;
        }


        if (status == 'approved') {
            const status = await checkBookingStatusForApprove(record._id);
            if (status.status == false) {
                message.error(status.message);
                return;
            }

            const cust_id = record.cust_id ? `/${record.cust_id}` : '';
            const veh_id = record.veh_id ? `/${record.veh_id}` : '';

            history(`/new-agreement${cust_id}${veh_id}/${record._id}`);
            return;
        }
        const onSuccess = (res) => {

            if (status == 'approved') {
                history(`/generate-agreement/${record._id}`);
                // message.success("Booking request has been approved!");
                // dispatch(setLoader(false))
            }
            else {
                message.success("Booking rejected");
            }
        }
        const onError = (err) => {
            console.log('err', err)
            dispatch(setLoader(false))
        }

        const body = {
            token: user?.token,
            booking_id: record._id,
            status: status
        };
        dispatch(setLoader(true))
        await postRequest(body, apiRoutes.changeBookingStatus, onSuccess, onError)

    };

    const changeTab = (type) => {
        setActiveTab(type);
        if (type == 'allBookings') {
            setData(requests);
        }
        else if (type == 'pending') {
            setData(pending);
        }
        else if (type == 'approved') {
            setData(approved);
        }
        else if (type == 'rejected') {
            setData(rejected);
        }
        else if (type == 'returned') {
            setData(returned);
        }
    }





    const columns = [
        {
            title: 'Veh name',
            dataIndex: 'veh_name',
            key: 'name',
            render: (text, record) => <Link
                style={{ color: appColors.primary, textDecoration: 'underline', fontFamily: 'Poppins', }}
                to={{
                    pathname: `/vehicle-details/${record?.veh_id}`,
                    state: record,
                }}
            >
                {text}
            </Link>,
        },
        {
            title: 'Reg no',
            dataIndex: 'reg_no',
            key: 'reg_no',
        },
        {
            title: 'Model',
            dataIndex: 'model',
            key: 'model',
        },
        {
            title: 'Rent',
            dataIndex: 'rent',
            key: 'rent',
        },
        {
            title: 'Cust name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => <Link
                style={{ color: appColors.primary, textDecoration: 'underline', fontFamily: 'Poppins', }}
                to={{
                    pathname: `/user-details/${record?.cust_id}`,
                    state: record,
                }}
            >
                {text}
            </Link>,
        },

        // {
        //     title: 'Cust name',
        //     dataIndex: 'name',
        //     key: 'name',
        // },
        {
            title: 'Cust email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Cust phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_, record) => (
                <div>
                    <Typography style={{ fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600, }}>
                        {new Date(record.created_at).toLocaleString()}
                    </Typography>

                </div>
            ),
        },
        {
            title: 'Cust address',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => (
                <div>
                    <Typography style={{ fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600, }}>
                        {capitalizeFirstLetter(record.status)}
                    </Typography>

                </div>
            ),
        },

        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Dropdown
                    overlay={


                        <Menu onClick={({ key }) => handleActionClick(key, record)}>
                            {
                                record.status == 'rejected' &&
                                <>
                                    <Menu.Item key="approve">Approve</Menu.Item>
                                    <Menu.Item key="delete">Delete</Menu.Item>
                                </>
                            }
                            {
                                record.status == 'pending' &&
                                <>
                                    <Menu.Item key="approve">Approve</Menu.Item>
                                    <Menu.Item key="reject">Reject</Menu.Item>
                                    <Menu.Item key="delete">Delete</Menu.Item>
                                </>
                            }

                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button>
                        <MoreOutlined style={{ fontWeight: 'bolder' }} />
                    </Button>
                </Dropdown>
            ),

        },
    ];



    useEffect(() => {
        getBookingRequests()
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>

                <Modal
                    title="Are you sure you want to delete this booking request?"
                    visible={deletedModal}
                    onCancel={() => setDeletedModal(false)}
                    footer={[
                        <Button key="cancel" onClick={() => {
                            setDeletedModal(false);
                            setDeletedId('');
                        }}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={() => {
                            setDeletedModal(false);
                            deleteBookingRequest();
                        }}>
                            Delete
                        </Button>,
                    ]}
                >
                    {/* <p>Deleting this note will parmanently delete. You will never recover this note.</p> */}
                </Modal>



                <div style={{ display: 'flex', }}>
                    <Sidebars />
                    <div style={{ marginLeft: 10 }}>
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Booking requests
                        </span>

                        <div style={tabContainer} >
                            <div
                                onClick={() => changeTab('allBookings')}
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}>
                                <Typography sx={tabText} >
                                    All Bookings
                                </Typography>
                                {activeTab == 'allBookings' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('pending')}
                            >
                                <Typography sx={tabText} >
                                    Pending
                                </Typography>
                                {activeTab == 'pending' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('approved')}
                            >
                                <Typography sx={tabText} >
                                    Approved
                                </Typography>
                                {activeTab == 'approved' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('rejected')}
                            >
                                <Typography sx={tabText} >
                                    Rejected
                                </Typography>
                                {activeTab == 'rejected' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('returned')}
                            >
                                <Typography sx={tabText} >
                                    Returned
                                </Typography>
                                {activeTab == 'returned' && <div style={focusedTabLine} />}
                            </div>

                        </div>


                        <div>
                            <DataTable data={data} columns={columns} />
                        </div>
                    </div>



                </div>
            </ThemeProvider>
        </>
    )

}

const tabContainer = {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'white',
    width: 420,
    borderRadius: 15,
    paddingTop: 10, paddingRight: 20, paddingLeft: 20,
    justifyContent: 'space-between',
    boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',


}
const tabText = {
    fontSize: 14,
    color: '#000000',
    fontFamily: 'Poppins',


}

const focusedTabLine = {
    backgroundColor: appColors.primary,
    width: 55,
    height: 2,
    marginTop: 5

}

export default BookingRequests
